import { useEffect, useMemo, useState } from "react";
import { filterObjectByKeys, disabledFilterTooltipTitle } from "./DreamSearchFilter";
import debounce from "lodash/debounce";
import { useDreamSearchContext } from "../../../DreamSearchContext";
import { ProgramEnvironmentToNameMap } from "@portal/app/_common/lib/programHelpers";
import isEmpty from "lodash/isEmpty";
import { EnumMultiSelectChipFilter } from "@portal/app/manage/_components/DreamTable";
import { FilterComponentProps } from "./DreamSearchFilter";

export const ClassFormatFilterComponent = ({
  value,
  setValue,
  setHasOptions,
}: FilterComponentProps<GQL.ProgramEnvironment[]>) => {
  const { filterSettings } = useDreamSearchContext();
  const [localValue, setLocalValue] = useState<GQL.ProgramEnvironment[]>(value);
  const [availableOptions] = useState(
    filterObjectByKeys(ProgramEnvironmentToNameMap, filterSettings?.environment)
  );

  const debounceSetValue = useMemo(
    () => debounce((localValue: GQL.ProgramEnvironment[]) => setValue(localValue), 500),
    [setValue]
  );

  useEffect(() => {
    if (filterSettings) {
      setHasOptions(Object.keys(availableOptions).length > 0);
    }
  }, [availableOptions, filterSettings, setHasOptions]);

  return (
    <EnumMultiSelectChipFilter<GQL.ProgramEnvironment>
      label="Class format"
      value={localValue}
      id="class-format"
      setValue={(value: GQL.ProgramEnvironment[]) => {
        const newValue = isEmpty(value) ? [] : value;
        setLocalValue(newValue);
        debounceSetValue(newValue);
      }}
      enumToFriendlyMap={availableOptions}
      disabledTooltipTitle={disabledFilterTooltipTitle}
    />
  );
};
